module.exports = __webpack_public_path__ + "img/JCB_LOCAL.53619175.svg";